import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'accent' | 'white';
  href?: string;
  className?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  href,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 font-display font-bold text-lg border-3 border-text rounded-2xl neo-shadow transition-colors';
  const variants = {
    primary: 'bg-primary hover:bg-[#8cc629]',
    secondary: 'bg-secondary hover:bg-[#a794fa]',
    accent: 'bg-accent hover:bg-[#eab308]',
    white: 'bg-white hover:bg-gray-100'
  };
  const content = <motion.div whileHover={{
    scale: 1.05,
    y: -2
  }} whileTap={{
    scale: 0.95,
    y: 2,
    boxShadow: '0px 0px 0px 0px rgba(26,26,26,1)'
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} className="inline-block" data-id="element-12">
      {href ? <a href={href} target={href.startsWith('http') ? '_blank' : '_self'} rel={href.startsWith('http') ? 'noopener noreferrer' : ''} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-13">
          {children}
        </a> : <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-14">
          {children}
        </button>}
    </motion.div>;
  return content;
};